<div class="background"></div>

<div class="inner" [style.text-align]="textAlign()">
  <div class="scroll">
    @if (type() === "info") {
      <button mat-icon-button (click)="close()" class="close-button">
        <mat-icon>close</mat-icon>
      </button>
    }

    @if (type() === "error" || type() === "loading" || type() === "success") {
      <img src="assets/images/dialog-banner.png" alt="banner" class="banner" />
    }

    <div class="text">
      @if (type() === "warning" || type() === "confirm") {
        <div class="icon-wrapper">
          @switch (type()) {
            @case ("warning") {
              <mat-icon>priority_high</mat-icon>
            }
            @case ("confirm") {
              <mat-icon>question_mark</mat-icon>
            }
          }
        </div>
      }

      <div class="title-wrapper">
        @if (type() === "info") {
          <div class="title-horizontal-line"></div>
        }
        <div class="title" [innerHTML]="title()"></div>
        @if (type() === "info") {
          <div class="title-horizontal-line"></div>
        }
      </div>

      @if (content()) {
        <div class="content" [innerHTML]="content()"></div>
      }
    </div>

    @if (buttons().length > 0) {
      <div class="buttons">
        @for (button of buttons(); track button.label) {
          <button
            mat-raised-button
            [style.background]="button.color"
            (click)="clickButton(button)"
          >
            {{ button.label }}
          </button>
        }
      </div>
    } @else {
      <div class="empty-buttons"></div>
    }
  </div>
</div>
